import request from '@/utils/request';

export function login(data) {
  return request({
    url: '/admin/verification/login',
    method: 'post',
    data: data,
  });
}

export function zjerLogin(data) {
  return request({
    url: '/admin/verification/zjerLogin',
    method: 'post',
    data: data,
  });
}
export function sendSmsByToken(data) {
  return request({
    url: '/admin/verification/login/sendSmsByToken',
    method: 'post',
    data: data,
  });
}

// 绑定发送短信验证码
export function zjerBindingSms(data) {
  return request({
    url: '/admin/verification/zjerBinding/sendSms',
    method: 'post',
    data: data,
  });
}

// 获取短信验证码
export function getCodeApi(data) {
  return request({
    url: `/admin/verification/login/sendSms`,
    method: 'post',
    data,
  });
}

// 绑定手机号
export function zjerBinding(data) {
  return request({
    url: '/admin/verification/zjerBinding',
    method: 'post',
    data: data,
  });
}

// 获取下拉学校
// export function selectSchool(query){
//   return request({
//     url:'/admin/verification/selectSchool',
//     method:'get',
//     query
//   })
// }

export function refreshToken(data) {
  return request({
    url: '/admin/refreshToken',
    method: 'post',
    data,
  });
}

export function refresh(data) {
  return request({
    url: '/admin/verification/refresh',
    method: 'post',
    data,
  });
}

export function captcha(data) {
  return request({
    url: '/admin/verification/captcha',
    method: 'get',
    params: { t: data },
  });
}

export function getInfo() {
  return request({
    url: '/admin/admin/info',
    method: 'get', // ,
    // params: { adminid }
  });
}

export function logout() {
  return request({
    url: '/admin/admin/logout',
    method: 'get',
  });
}

export function checkRole(data) {
  return request({
    url: '/admin/admin/checkUserType',
    method: 'post',
    data,
  });
}

export function getUndoNum() {
  return request({
    url: '/admin/feedback/unHandleNum',
    method: 'get',
  });
}
